angular.module('impactx.lot').controller('LotSubSupplierDetailCtrl', LotSubSupplierDetailCtrl);
LotSubSupplierDetailCtrl.$inject = [
    '$scope',
    'dataGen',
    '$routeParams',
    'BackService',
    '$mdToast',
    'ConfirmationService',
    'ToolbarService'
];

function LotSubSupplierDetailCtrl($scope, dataGen, $routeParams, BackService, $mdToast, ConfirmationService, ToolbarService) {
    $scope.oldCompanySelected = null;
    var ctrl = this;

    dataGen.getData($scope, {
        id: $routeParams.id,
        lotSupplierId: $routeParams.lotSupplierId
    }, "/lot/subsupplierviewdetail").then(function () {
        defineButtons();
    });

    this.deleteDialog = function (event) {
        ConfirmationService.showConfirmationDialog(ctrl.delete, event, $scope.trns.confirmDelete,
            $scope.trns.delete, $scope.trns.abort);
    };

    this.delete = function () {
        var dataObj = {
            id: $scope.data.id
        };
        dataGen.postAsForm($scope, dataObj, "/lot/subsupplierdelete").then(function () {
            BackService.back();
            $mdToast.show(
                $mdToast.simple()
                    .textContent($scope.trns.saveSuccess)
                    .position("bottom right")
                    .hideDelay(10000)
            );
        });
    };

    this.onCompanySelect = function (selected) {
        //last condition means this is the initial load of the dialog where the inputs are already given.
        if (selected && ($scope.oldCompanySelected != selected.id) && $scope.oldCompanySelected != null) {
            var tempScope = {};
            dataGen.getData(tempScope, {
                lotSubSupplierId: $scope.data.id, lotSupplierId: $scope.data.lotSupplierId,
                comId: selected.id
            }, "/lot/subsuppliercontact").then(function () {
                if (tempScope.data.contact1User) {
                    $scope.data.contact1User.entries = tempScope.data.contact1User.entries;
                    $scope.data.contact3User.entries = tempScope.data.contact1User.entries;

                    $scope.data.contact1User.selected = tempScope.data.contact1User.selected;
                    $scope.data.contact3User.selected = tempScope.data.contact1User.selected;
                }
                else {
                    $scope.data.contact1User.selected = {};
                    $scope.data.contact3User.selected = {};

                    if ($scope.data.contact1User.entries)
                        $scope.data.contact1User.entries.length = 0;
                    if ($scope.data.contact3User.entries)
                        $scope.data.contact3User.entries.length = 0;
                }
            });
        }
        else {
            if (!selected && $scope.oldCompanySelected != null) {
                $scope.data.contact1User.selected = {};
                $scope.data.contact3User.selected = {};
                if ($scope.data.contact1User.entries)
                    $scope.data.contact1User.entries.length = 0;
                if ($scope.data.contact3User.entries)
                    $scope.data.contact3User.entries.length = 0;
            }
            $scope.oldCompanySelected = 0;
        }
    };

    this.saveLotSubSupplier = function () {
        var dataObj = {
            lotSubSupplier: $scope.data
        };
        return dataGen.postAsForm($scope, dataObj, "/lot/subsuppliersave").then(function () {
            BackService.back();
            $mdToast.show(
                $mdToast.simple()
                    .textContent($scope.trns.saveSuccess)
                    .position("bottom right")
                    .hideDelay(10000)
            );
        });
    };

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: ctrl.saveLotSubSupplier,
                type: 'validation',
                //condition: isEditable,
                params: {
                    form: $scope.dialogData
                }
            },
            {
                label: $scope.trns.delete,
                action: ctrl.deleteDialog,
                type: 'dialogaction',
                condition: canDelete
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function isEditable() {
        return !$scope.data.readOnly;
    }

    function canDelete() {
        return !$scope.data.readOnly && !$scope.data.mainPartReadOnly && $scope.data.id > 0;
    }
}